import React, { useCallback } from 'react';
import { OutlinedButton, PrimaryButton } from '@bloomberg/media-ui-core';
import { ExitThin, Lock } from '@bloomberg/media-ui-icons';
import { useQuickAdd } from '@foundation/quickadd-provider';

import styles from './QuickAddSubscribe.module.css';

type QuickAddSubscribeProps = {
  onClose: () => void;
  onSignInClick: () => void;
  isLoggedIn: boolean;
};

const SUBSCRIBE_MESSAGE =
  'Subscribe or sign in to Bloomberg.com to get access to Watchlist and other great benefits.';

const UPGRADE_MESSAGE =
  'Upgrade to get access to Watchlist and other great benefits.';

export const QuickAddSubscribe = (props: QuickAddSubscribeProps) => {
  const { onClose, onSignInClick, isLoggedIn } = props;
  const { subscriberType } = useQuickAdd();

  const isNewsletterSubscriber = subscriberType === 'Newsletter';

  const openSignInModal = useCallback(() => {
    onSignInClick();
  }, [onSignInClick]);

  const goToSubscriptionPage = useCallback(() => {
    window.open('https://www.bloomberg.com/subscriptions', '_blank');
  }, []);

  const goToPortalSubscriptionUpgradePage = useCallback(() => {
    window.open(
      'https://www.bloomberg.com/portal/subscription?triggerSubscriptionUpgradeModal=true&in_source=watchlist-quick-add',
      '_blank'
    );
  }, []);

  return (
    <div className={styles.quickAddSubscribe}>
      <div className={styles.header}>
        <div className={styles.titleContainer}>
          <Lock />
          <p>Watchlist is Subscriber-only</p>
        </div>
        <button className={styles.closeButton} onClick={onClose}>
          <ExitThin />
        </button>
      </div>
      <p className={styles.description}>
        {isNewsletterSubscriber ? UPGRADE_MESSAGE : SUBSCRIBE_MESSAGE}
      </p>
      <div className={styles.buttonsContainer}>
        <PrimaryButton
          className={styles.subscribeButton}
          onClick={
            isNewsletterSubscriber
              ? goToPortalSubscriptionUpgradePage
              : goToSubscriptionPage
          }
          size="small"
          title="subscribe"
          version="phoenix"
        >
          {isNewsletterSubscriber ? 'Upgrade' : 'Subscribe'}
        </PrimaryButton>
        {!isLoggedIn && (
          <OutlinedButton
            className={styles.signInButton}
            onClick={openSignInModal}
            size="small"
            title="sign in"
            version="phoenix"
          >
            Sign In
          </OutlinedButton>
        )}
      </div>
    </div>
  );
};
